import Axios, { type AxiosResponse } from "axios";
import { ENV_CONFIG } from "common/config/env.config";

const engAxiosInstance = Axios.create({
  baseURL: `${ENV_CONFIG.ENG_API_URL}`,
  timeout: 300000
});

engAxiosInstance.interceptors.response.use((response: AxiosResponse) => {
  return response;
});

// TODO : Remove any here
engAxiosInstance.interceptors.request.use((request: any) => {
  return request;
});

export default engAxiosInstance;
